import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Company } from '@/types';
import { companiesApi } from '@/services/api';

interface CompanyState {
  current: Company | null;
  companies: Company[];
  isLoading: boolean;
  error: string | null;
}

const initialState: CompanyState = {
  current: null,
  companies: [],
  isLoading: false,
  error: null,
};

export const fetchCompanies = createAsyncThunk(
  'company/fetchCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const response = await companiesApi.list();
      if (!response.success) {
        return rejectWithValue(response.error?.message || 'Erro ao carregar empresas');
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Erro ao carregar empresas');
    }
  }
);

export const updateCompanySettings = createAsyncThunk(
  'company/updateSettings',
  async ({ id, settings }: { id: string; settings: any }, { rejectWithValue }) => {
    try {
      const response = await companiesApi.updateSettings(id, settings);
      if (!response.success) {
        return rejectWithValue(response.error?.message || 'Erro ao atualizar configurações');
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Erro ao atualizar configurações');
    }
  }
);

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCurrentCompany: (state, action: PayloadAction<Company>) => {
      state.current = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.isLoading = false;
        state.companies = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(updateCompanySettings.fulfilled, (state, action) => {
        if (state.current && state.current.id === action.payload.id) {
          state.current = action.payload;
        }
      });
  },
});

export const { setCurrentCompany, clearError } = companySlice.actions;
export default companySlice.reducer;